<template>
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 xl:max-w-screen-2xl">
        <slot />
    </div>
</template>